/* The home "Nuestras tiendas" row (sections/munne-stores-carousel.liquid).
   The shops live on the stores page, so that page is fetched once the
   browser is idle, and each [data-munne-store] becomes a slide. */
(function () {
  const WIDTHS = [750, 1100, 1500, 2200, 3000];

  const withWidth = (url, width) => `${url}${url.includes('?') ? '&' : '?'}width=${width}`;

  const build = (root, stores) => {
    const template = root.querySelector('template');
    const track = root.querySelector('.munne-stores-carousel__track');

    stores.forEach((store, index) => {
      const slide = template.content.firstElementChild.cloneNode(true);
      const name = store.querySelector('.munne-store__name');
      const lines = store.querySelector('.munne-store__lines');
      const image = slide.querySelector('img');

      slide.id = `Slide-${track.id}-${index + 1}`;
      slide.querySelector('.munne-stores-carousel__name').textContent = name ? name.textContent.trim() : '';
      if (lines) slide.querySelector('.munne-stores-carousel__card').append(document.importNode(lines, true));

      if (store.dataset.image) {
        image.srcset = WIDTHS.map((width) => `${withWidth(store.dataset.image, width)} ${width}w`).join(', ');
        image.src = withWidth(store.dataset.image, 1500);
        image.alt = name ? name.textContent.trim() : '';
      } else {
        image.remove();
      }

      track.append(slide);
    });

    root.hidden = false;
    // Dawn's slider-component counted its slides before there were any.
    root.querySelector('slider-component').resetPages();
  };

  const load = (root) => {
    if (!root.dataset.url) return;
    fetch(root.dataset.url)
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        const stores = new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-munne-store]');
        if (stores.length) build(root, Array.from(stores));
      })
      .catch(() => {
        // The row stays hidden.
      });
  };

  // After everything else on the page: the row is far down the landing.
  const start = () => document.querySelectorAll('[data-munne-stores-carousel]').forEach(load);
  if ('requestIdleCallback' in window) {
    requestIdleCallback(start);
  } else {
    setTimeout(start, 1);
  }
})();
